/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { ValuesOf } from '@tmapy/beetlejuice-utils';

/**
 * ```yaml
 * type: string
 * description: |-
 *   * `CUSTOM` - Custom
 *   * `CADASTER` - Cadaster
 *   * `MOMC` - Momc
 *   * `OBEC` - Obec
 *   * `ORP` - ORP
 *   * `KRAJ` - Kraj
 * ```
 */
export const OrderRegionTypesEnum = {
  CUSTOM: 'CUSTOM',
  CADASTER: 'CADASTER',
  MOMC: 'MOMC',
  OBEC: 'OBEC',
  ORP: 'ORP',
  KRAJ: 'KRAJ',
} as const;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type OrderRegionTypesEnum = ValuesOf<typeof OrderRegionTypesEnum>;

export type OrderRegionTypesEnumRequest = OrderRegionTypesEnum;
export type OrderRegionTypesEnumResponse = OrderRegionTypesEnum;
